import { RowCrudStatus } from "../../common/types";
import {
  AlertSubscription,
  AlertSubscriptionCreateMutationVariables,
  AlertSubscriptionUpdateMutationVariables,
} from "../../../api/graphql";
import { LangStore } from "../../../store";
import { alertRuleDisplayId } from "../../alertRule/store/AlertRuleCommonStore";

export type AlertSubscriptionValuesType = {
  id: string;
  displayId: string;
  version_: string;
  __status__: RowCrudStatus;
  __alertRule: string;
  showAlertRule: { displayId: string; id: string } | null;
  enabled: boolean;
};

export type AlertSubscriptionErrorsType = {
  alertRule?: { message: string; fieldLabel: string };
  enabled?: { message: string; fieldLabel: string };
};

export function AlertSubscriptionValuesInit(): AlertSubscriptionValuesType {
  return {
    id: "",
    displayId: "",
    version_: "",
    __status__: "empty",
    __alertRule: "",
    showAlertRule: null,
    enabled: false,
  };
}

export type AlertSubscriptionType =
  | AlertSubscription
  | AlertSubscriptionValuesType;

export function alertSubscriptionDisplayId(
  source: Partial<AlertSubscription>,
  _langStore: LangStore
) {
  return source.alertRule
    ? alertRuleDisplayId(source.alertRule, _langStore)
    : _langStore.emptyStringSymbol;
}

export function getAlertSubscriptionValues(
  source: AlertSubscriptionType,
  _langStore: LangStore,
  _duplicated: boolean = false
): AlertSubscriptionValuesType {
  const entityValues = AlertSubscriptionValuesInit();
  entityValues.id = source.id;
  entityValues.displayId =
    "__status__" in source
      ? source.displayId
      : alertSubscriptionDisplayId(source, _langStore);
  entityValues.version_ = source.version_;
  entityValues.showAlertRule =
    "alertRule" in source && source.alertRule
      ? {
          id: source.alertRule.id,
          displayId: alertRuleDisplayId(source.alertRule, _langStore),
        }
      : "showAlertRule" in source && source.showAlertRule
      ? {
          id: source.showAlertRule.id,
          displayId: source.showAlertRule.displayId,
        }
      : null;
  entityValues.__alertRule = entityValues.showAlertRule?.displayId || "";
  entityValues.enabled = source.enabled || false;
  if (_duplicated) {
    entityValues.__status__ = "added";
  } else if ("__status__" in source) {
    entityValues.__status__ = source.__status__;
  }
  return entityValues;
}

export function getAlertSubscriptionUpdateVariables(
  values: AlertSubscriptionValuesType
): AlertSubscriptionUpdateMutationVariables {
  return {
    id: values.id,
    version_: values.version_,
    alertRuleId: values.showAlertRule?.id || "",
    enabled: values.enabled,
  };
}

export function getAlertSubscriptionCreateVariables(
  values: AlertSubscriptionValuesType
): AlertSubscriptionCreateMutationVariables {
  return {
    alertRuleId: values.showAlertRule?.id || "",
    enabled: values.enabled,
  };
}
